import { Chip } from "@mui/joy";

export type BallInCourt = "Design Team" | "Owner" | "Subcontractor" | "Contractor" | "N/A";

const config: Record<
    BallInCourt,
    {
        color: "primary" | "warning" | "success" | "danger" | "neutral";
        defaultLabel: string;
    }
> = {
    "Design Team": {
        color: "primary",
        defaultLabel: "Design Team",
    },
    Owner: {
        color: "warning",
        defaultLabel: "Owner",
    },
    Subcontractor: {
        color: "success",
        defaultLabel: "Subcontractor",
    },
    Contractor: {
        color: "danger",
        defaultLabel: "Contractor",
    },
    "N/A": {
        color: "neutral",
        defaultLabel: "N/A",
    },
};

interface BallInCourtChipProps {
    ballInCourt: BallInCourt;
    label?: string;
}

export const BallInCourtChip = ({ ballInCourt, label }: BallInCourtChipProps) => {
    const { color, defaultLabel } = config[ballInCourt];

    return (
        <Chip variant="soft" size="sm" color={color} sx={{ textTransform: "capitalize" }}>
            {label ?? defaultLabel}
        </Chip>
    );
};
